import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { ToastInterface } from '~/component/toast/interfaces/toast.interface';

@Injectable({
  providedIn: 'root',
})
export class ToastsService {
  private readonly toastsSubject$ = new Subject<ToastInterface>();

  public get onNewToast$(): Observable<ToastInterface> {
    return this.toastsSubject$.asObservable().pipe(distinctUntilChanged());
  }

  public push(toast: ToastInterface): void {
    this.toastsSubject$.next(toast);
  }
}
